var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFlag = function SvgIconFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-flag_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-flag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M5.833 11.667v5c0 .236-.08.434-.24.593A.806.806 0 0 1 5 17.5a.806.806 0 0 1-.594-.24.806.806 0 0 1-.24-.593v-12.5c0-.236.08-.434.24-.594.16-.16.358-.24.594-.24h5.98a.8.8 0 0 1 .52.188c.153.125.25.285.292.479L12 5h3.833c.236 0 .434.08.594.24.16.16.24.357.24.593V12.5c0 .236-.08.434-.24.594a.806.806 0 0 1-.594.24h-4.312a.8.8 0 0 1-.521-.188.825.825 0 0 1-.292-.48l-.208-1H5.833Zm6.375 0H15v-5h-3.688a.8.8 0 0 1-.52-.188A.825.825 0 0 1 10.5 6l-.208-1H5.833v5h5.354a.8.8 0 0 1 .521.188c.153.124.25.284.292.479l.208 1Z"
  }))));
};
export default SvgIconFlag;